export default "__VITE_ASSET__DoNcibzU__"